import {DetailsCell} from "./DetailsCell";

interface UserDetailsProps{
    graphData?:any;
    isAuthenticated:Boolean;
    photo:string;
    signinHandler:()=>void;
    signoutHandler:()=>void;
   }

    ///Questo componente mostra i dettattagli dell'utente loggato
    ///NB: per il momento abbiamo inserito una immagine di default per via di alcuni problemi con il recupero dell'immagine da Graph

   export const UserDetails: React.FC<UserDetailsProps> = ({graphData,isAuthenticated,photo,signinHandler,signoutHandler}) => {
    return (
        <div className="container-fluid pb-5">

                { isAuthenticated==true &&
                        <>
                            <div className="row">
                                <div className="col my-auto">
                                    <form >
                                        <div className="form-group row">
                                            <DetailsCell classCSS="col sm-6 mb-3" title="First Name" value={graphData===null || graphData===undefined ? "": graphData.givenName}/>
                                            <DetailsCell classCSS="col sm-6 mb-3" title="Last Name" value={graphData===null || graphData===undefined ? "": graphData.surname}/>
                                        </div>
                                        <div className="form-group row">
                                            <DetailsCell classCSS="col sm-6 mb-3" title="Email" value={graphData===null || graphData===undefined ? "": graphData.userPrincipalName}/>
                                            <DetailsCell  classCSS="col sm-6 mb-3" title="Job Title:" value={graphData===null || graphData===undefined ? "": graphData.jobTitle}/>
                                        </div>                
                                    </form>
                                </div>
                            </div>
                        </>
                    }
                
                { isAuthenticated==false &&
                    <div className="row">
                        <div className="col my-auto">
                            <span className="text-center">
                                <h6 className='d-block d-sm-none'>Please, Sign-In to the app</h6>
                                <h4 className='d-none d-sm-block'>Please, Sign-In to the app</h4>
                            </span>
                        </div>
                    </div>
                    }
                <div className="row">
                    { isAuthenticated==false  && <button type="button" className="btn btn-primary btn-sm" onClick={signinHandler}>Sign in</button>}
                    { isAuthenticated==true  &&  <button type="button" className="btn btn-danger btn-sm" onClick={signoutHandler}>Sign Out</button>}
                </div>
            </div>
        );
  
      }   